import { DateTimeFormatter, LocalDate } from '@js-joda/core';
import styled from 'styled-components';

import { TextView } from '@dreryk/react-components';

import { patientTranslationKeys } from '../../../translations';

const StyledTextView = styled(TextView)`
   flex: 1;
`;

StyledTextView.displayName = 'StyledTextView';

type BirthDateTextViewProps = {
   readonly birthDate: LocalDate | null;
};

const BirthDateTextView = (props: BirthDateTextViewProps): JSX.Element => {
   return (
      <StyledTextView label={patientTranslationKeys.birthDate} testId={'birthDate'}>
         {props.birthDate?.format(DateTimeFormatter.ofPattern('dd.MM.yyyy')) ?? '-'}
      </StyledTextView>
   );
};

export { BirthDateTextView };
